import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';

import { routes } from './app.routes';
import { AuthGuardService } from 'src/services/auth-guard.service';
import { ServerErrorInterceptorService } from 'src/services/server-error-interceptor.service';
import { AuthTokenInterceptorService } from 'src/services/auth-token-interceptor.service';
import { DateNovoService } from 'src/services/date-novo.service';

registerLocaleData(localeFr);

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection(),
        provideRouter(routes),
        provideAnimations(),
        importProvidersFrom(
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: HttpLoaderFactory,
                    deps: [HttpClient]
                },
                defaultLanguage: 'fr'
            })
        ),
        AuthGuardService,
        { provide: HTTP_INTERCEPTORS, useClass: ServerErrorInterceptorService, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: AuthTokenInterceptorService, multi: true },
        provideHttpClient(withInterceptorsFromDi()),
        { provide: DateAdapter, useClass: DateNovoService },
        { provide: MAT_DATE_LOCALE, useValue: 'fr-CA' }
    ]
};
